import React, { useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { StoryblokComponent, useStoryblokState } from 'gatsby-source-storyblok';
import { useAppState } from '../../../context/app-state.context';

const HeaderWrapper = () => {
  const data = useStaticQuery(graphql`
    query HeaderStoryQuery {
      storyblokEntry(full_slug: { eq: "header" }) {
        content
        full_slug
        internalId
        name
        uuid
      }
    }
  `);

  const story = useStoryblokState(data.storyblokEntry);

  const { hamburgerMenuIsOpen } = useAppState();

  // prevent scroll if menu is open
  useEffect(() => {
    const contentEl = document.getElementById('bodyContent');
    if (hamburgerMenuIsOpen) {
      contentEl.classList.add('overflow-hidden');
    } else {
      contentEl.classList.remove('overflow-hidden');
    }
  }, [hamburgerMenuIsOpen]);

  return story?.content && <StoryblokComponent blok={story.content} />;
};

export default HeaderWrapper;
